import { Link, useLocation } from "wouter";
import { Home, LayoutGrid, Plus, MessageSquare, User } from "lucide-react";
import { useState } from "react";
import { PostMenu } from "./PostMenu";
import { useAuth } from "../lib/auth";

/**
 * Mobile-only bottom tab bar (hidden on lg+). Matches the approved mockup:
 * Home · Market · [＋ Post] · Messages · Account, with a raised red FAB in the
 * middle that opens the Post menu. Desktop navigation is unchanged (Header).
 */
export function BottomNav() {
  const [loc, navigate] = useLocation();
  const [post, setPost] = useState(false);
  const { user } = useAuth();

  const is = (path: string) => (path === "/" ? loc === "/" : loc.startsWith(path));
  const accountHref = user ? "/dashboard" : "/login";
  const tab = (active: boolean) =>
    `flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold ${active ? "text-brand-red" : "text-mut"}`;

  return (
    <>
      {/* spacer so fixed bar never covers page content */}
      <div className="h-16 lg:hidden" aria-hidden="true" />
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-line flex items-stretch h-16 pb-[env(safe-area-inset-bottom)]"
        aria-label="Primary"
      >
        <Link href="/" className={tab(is("/"))}>
          <Home className="w-[22px] h-[22px]" strokeWidth={1.8} /> Home
        </Link>
        <Link href="/marketplace" className={tab(is("/marketplace"))}>
          <LayoutGrid className="w-[22px] h-[22px]" strokeWidth={1.8} /> Market
        </Link>

        {/* center FAB */}
        <div className="flex-1 flex items-start justify-center">
          <button
            type="button"
            onClick={() => setPost(true)}
            aria-label="Post"
            className="-mt-5 w-12 h-12 rounded-2xl bg-brand-red text-white grid place-items-center shadow-lg shadow-brand-red/40 ring-4 ring-white active:scale-95 transition"
          >
            <Plus className="w-6 h-6" strokeWidth={2} />
          </button>
        </div>

        <Link href="/messages" className={tab(is("/messages"))}>
          <MessageSquare className="w-[22px] h-[22px]" strokeWidth={1.8} /> Messages
        </Link>
        <Link href={accountHref} className={tab(is("/dashboard"))}>
          <User className="w-[22px] h-[22px]" strokeWidth={1.8} /> Account
        </Link>
      </nav>
      <PostMenu open={post} onClose={() => setPost(false)} />
    </>
  );
}
